const paramIsDefined = (variable, params)=>params[variable] !== undefined && params[variable] !== null && params[variable] !== 'undefined' && params[variable] !== '';
const concatUrlParam = (url, urlParam, value)=>url.concat(`&${urlParam}=`).concat(encodeURIComponent(String(value)));
const getRouteParamsUrl = (endpoint, routeParams)=>endpoint.split('/').map((part)=>{
        if (part.startsWith(':')) {
            const paramName = part.slice(1);
            return paramIsDefined(paramName, routeParams) ? routeParams[paramName] : `undefined(${paramName})`;
        } else if (part.startsWith('?:')) {
            const paramName = part.slice(2);
            return paramIsDefined(paramName, routeParams) ? routeParams[paramName] : undefined;
        }
        return part;
    }).filter((part)=>part !== undefined).join('/');
const getPathVariableUrl = (routeParamsUrl, pathVariables)=>Object.keys(pathVariables).filter((variable)=>paramIsDefined(variable, pathVariables)).reduce((restUrl, urlAttribute)=>restUrl.concat(`/${urlAttribute}/${pathVariables[urlAttribute]}`), routeParamsUrl);
const getUrlParamsUrl = (pathVariableUrl, urlParams)=>{
    const params = Object.keys(urlParams).filter((variable)=>paramIsDefined(variable, urlParams));
    return params.length === 0 ? pathVariableUrl : params.reduce((restUrl, urlParam)=>{
        const value = urlParams[urlParam];
        if (Array.isArray(value)) {
            return restUrl.concat(value.reduce((acc, cur)=>concatUrlParam(acc, urlParam, cur), ''));
        }
        return concatUrlParam(restUrl, urlParam, value);
    }, `${pathVariableUrl}?`).replaceAll('?&', '?');
};
/**
 * Construct rest url
 *
 * @documented
 * @category String
 *
 * @param {String} endpoint
 * @param {Object} urlData {pathVariables, routeParams, urlParams}
 * @import import { getRestUrl } from '@gef-ui/utils/getRestUrl';
 * @return {String} endpoint url extended with path variables, route params and url params
 */ const getRestUrl = (endpoint, { pathVariables, routeParams, urlParams } = {})=>{
    let finalUrl = endpoint;
    if (routeParams) {
        finalUrl = getRouteParamsUrl(finalUrl, routeParams);
    }
    if (pathVariables) {
        finalUrl = getPathVariableUrl(finalUrl, pathVariables);
    }
    if (urlParams) {
        finalUrl = getUrlParamsUrl(finalUrl, urlParams);
    }
    return finalUrl;
};
export default getRestUrl;
